export default "__VITE_ASSET__DdtnwL18__"